import { useEffect, useState } from 'react';
import { getQueuedCount } from '../lib/offlineQueue';

// Tracks how many mutations are sitting in the IndexedDB offline replay
// queue. Refreshes on the queue:enqueued / queue:drained events that
// lib/api.ts and lib/sw.ts dispatch, plus `online` (a reconnect is
// about to drain the queue). Gives the UI a persistent pending count —
// the PwaToasts confirmations are transient and easy to miss.
export function useOfflineQueue(): { pending: number } {
  const [pending, setPending] = useState(0);

  useEffect(() => {
    let cancelled = false;
    const refresh = () => {
      void getQueuedCount().then((n) => {
        if (!cancelled) setPending(n);
      });
    };
    refresh();
    window.addEventListener('queue:enqueued', refresh);
    window.addEventListener('queue:drained', refresh);
    window.addEventListener('online', refresh);
    return () => {
      cancelled = true;
      window.removeEventListener('queue:enqueued', refresh);
      window.removeEventListener('queue:drained', refresh);
      window.removeEventListener('online', refresh);
    };
  }, []);

  return { pending };
}
